import { render, staticRenderFns } from "./supervisoryRole.vue?vue&type=template&id=11012fd0"
import script from "./supervisoryRole.vue?vue&type=script&lang=js"
export * from "./supervisoryRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports